import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import { fetchQuestions } from "../../redux/action-creaters/content";
import { setMetaFromData } from "../../redux/action-creaters/meta";
import Faq from "/components/pages/faq";
import Redis from "/lib/redis";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import { Api } from "../../api";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function FaqDetailPage({
  code,
  scripts,
  host,
  videos,
  isBaltex,
  isLanding,
}) {
  return (
    <Faq
      code={code}
      scripts={scripts}
      host={host}
      videos={videos}
      isBaltex={isBaltex}
      isLanding={isLanding}
    />
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ params, query, req, resolvedUrl }) => {
    await store.dispatch(await fetchQuestions(Redis, Boolean(query.reset)));
    const videos = await Api.content.getPromoVideos(
      Redis,
      Boolean(query.reset),
    );
    store.dispatch(addBreadcrumb({ link: "/faq/", name: "Вопросы и ответы" }));

    // Меты для разделов FAQ в базе нет, а страницы индексируются — без этого
    // они отдавались вовсе без title и description.
    const section = store
      .getState()
      .content.questionSections.find((item) => item.CODE === params.code);
    if (!section) {
      return { notFound: true };
    }
    store.dispatch(
      setMetaFromData({
        TITLE: `${section.NAME} — вопросы и ответы`,
        DESCRIPTION: `Ответы специалистов Фаркоп.ру на вопросы из раздела «${section.NAME}»`,
      }),
    );

    return pagesWrapper(
      {
        pageType: SITE_PAGE_TYPE.static,
        code: params.code,
        videos,
      },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/faq/",
      false,
    );
  }),
);
